import {
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
  UncontrolledDropdown,
  Spinner,
} from 'reactstrap';
import styled from 'styled-components';

const InlineDropdown = styled(UncontrolledDropdown)`
  display: inline-block;
`;

interface PickListItem<T> {
  name: string;
  id: string;
  item: T;
}

export interface PickListState<T> {
  isLoading: boolean;
  items: Array<PickListItem<T>>;
  selectedItem?: PickListItem<T>;
  error?: any;
}

export interface PickListProps<T> {
  defaultText?: string;
  selectedText?: (item: T) => string;
  onItemSelected?: (group: T) => void;
  color?: string;
  outline?: boolean;
  direction?: string;
  state: PickListState<T>;
}

const renderToggleContent = <T,>(props: PickListProps<T>) => {
  const { state } = props;
  if (state.isLoading) {
    return (
      <span>
        Loading Groups
        <span style={{ paddingLeft: '1em' }}>
          <Spinner size="sm" />
        </span>
      </span>
    );
  }

  if (state.error) {
    return 'Error Loading User Groups';
  }

  if (state.selectedItem) {
    if (props.selectedText != null) {
      return props.selectedText(state.selectedItem.item);
    }
    return state.selectedItem.name;
  } else {
    return props.defaultText ?? 'Select Item';
  }
};

export default <T,>(props: PickListProps<T>) => {
  const { state } = props;
  return (
    <InlineDropdown className="mr-2" direction={props.direction ?? 'left'}>
      <DropdownToggle
        outline={props.outline ?? false}
        color={props.color ?? (state.error != null ? 'danger' : 'seconday')}
      >
        {renderToggleContent(props)}
      </DropdownToggle>
      <DropdownMenu aria-labelledby="navbarDropdownMenuLink">
        {' '}
        {state.items &&
          state.items.map((item) => (
            <DropdownItem
              key={item.id}
              onClick={(e: any) => {
                const groupId = e.target.value;
                const group = state.items.filter((g) => g.id === groupId)[0];
                props.onItemSelected && props.onItemSelected(group.item);
              }}
              value={item.id}
            >
              {item.name}
            </DropdownItem>
          ))}
      </DropdownMenu>
    </InlineDropdown>
  );
};
